import MSTYComponent from './MSTY/index'

const MSTY = (): JSX.Element => (
  <MSTYComponent />
)

export default MSTY
